import { gql } from '@apollo/client'
import { useSafeRunMutation } from 'utils/mutations'

// ANNUAL_PHYSICAL_UPLOAD_ATTACHMENT

const mutation = gql`
  mutation annualPhysicalFormUploadAttachment(
    $id: ID!
    $attachment: AnnualPhysicalFormAttachmentInput!
  ) {
    annualPhysicalFormUploadAttachment(form_id: $id, attachment: $attachment) {
      id
      form_attachment {
        id
      }
    }
  }
`
export default function useAnnualUploadAttachment() {
  const { onMutate: onAnnualAttachmentUpload, loading } = useSafeRunMutation({
    mutation,
    responsePath: 'annualPhysicalFormUploadAttachment',
    successMessage: 'Attachment uploaded'
  })

  return { onAnnualAttachmentUpload, loading }
}
